import { ShippingStatus } from 'api/Shipment/types';
import { isFailureStatus, isReturnedStatus } from 'common/helpers/shipping';

export const isErrorTrack = (shippingStatus?: ShippingStatus) => {
  return isFailureStatus(shippingStatus?.status) || isReturnedStatus(shippingStatus?.status);
};
